module.exports = __webpack_public_path__ + "img/screen.a130db5e.svg";